import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';
import { HttpClientService } from '../implementacion/http-client.service';


@Injectable({
    providedIn: 'root'
  })

export class DatosService {
  constructor( private http: HttpClientService ) { }


  getcatalogo(Tipo: string) {
      if (Tipo === 'Tarifa') {
        return this.http.get(`${environment.apiScar}Deuda/ObtenerTarifas`)
        .pipe(map(response => response));
      } else {
          return null;
      }

  }
}
